// extracted by mini-css-extract-plugin
export default {"container":"wellControlsNavigation_container__y4YeG","navControl":"wellControlsNavigation_navControl__cauGR"};